<template>
  <div>
    <tr-typography variant="h5">
      Para ativar, use seu aplicativo de autenticação para ler o QR-Code, em seguida, insira o código gerado abaixo.
    </tr-typography>
    <div class="text-center vertical-offset2">
      <img
        :src="qrCodeSrc"
        alt="QR-Code"
      >
    </div>
    <div class="row center-h-and-v vertical-offset2">
      <tr-text-field
        v-model="code"
        autofocus="true"
        label="Digite o código gerado"
        required="true"
        name="code"
        no-margin="true"
        :exact-length="6"
        error-message="Código obrigatório e deve conter exatamente 6 números"
      />
    </div>
  </div>
</template>

<script>
import settingsResource from '@/commons/resources/settings';
import loggedUserResource from '@/commons/resources/loggedUser';
import { getMessage } from '@/commons/services/error';

export default {
  name: 'tfa-activation-dialog',
  props: {
    onSave: {
      required: true,
      type: Function
    }
  },
  data: () => ({
    qrCodeSrc: '',
    code: ''
  }),
  created() {
    return settingsResource.getTwoFactor().then(tfa => {
      this.qrCodeSrc = tfa.qrcode;
    });
  },
  methods: {
    onConfirm() {
      return settingsResource
        .setTwoFactor({
          action: 'enable',
          code: this.code
        })
        .then(
          data => {
            loggedUserResource.set(data.new_token);
            this.$toaster.success('Autenticação em 2 fatores ativada!');
            this.onSave();
          },
          error => {
            this.$toaster.error(getMessage(error));
          }
        );
    }
  }
};
</script>
